<template>
	<div>
		<!-- begin breadcrumb -->
		<ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item"><a href="javascript:;">Page Options</a></li>
			<li class="breadcrumb-item active">d3 Chart</li>
		</ol>
		<!-- end breadcrumb -->
		<!-- begin page-header -->
		<h1 class="page-header">Triangular <small>fuzzy membership function</small></h1>
		<!-- end page-header -->
		
		
		<!-- begin row -->
		<div class="row">
			<!-- begin col-6 -->
			<div class="col-lg-8">
				<!-- begin panel -->
				<panel title="Triangular fuzzy membership function">
					<div class="height-sm">
						<vn-line :model="lineChart.data" id="lineChart1"
							x-format=",.1f"
							y-format=",.2f"
							>
						</vn-line>
					</div>
				</panel>
				<!-- end panel -->
			</div>
			<div class="col-lg-4">
				<!-- begin panel -->
				<panel title="Coeficients">
					<div class="height-sm">

						<div class="form-group row m-b-15">
							<label class="col-form-label col-md-3">coefficient A</label>
							<div class="col-md-9">
							<input class="form-control"   type="number" placeholder="coefficient A" v-bind:coefA="value"   id="coefA" value="0"/>
							</div>
						</div>
						
						<div class="form-group row m-b-15">
							<label class="col-form-label col-md-3">coefficient B</label>
							<div class="col-md-9">
							<input class="form-control" type="number" placeholder="coefficient B" id="coefB" value="10"/>
							</div>
						</div>

						<div class="form-group row m-b-15">
							<label class="col-form-label col-md-3">coefficient C</label>
							<div class="col-md-9">
							<input class="form-control" type="number" placeholder="coefficient C"  id="coefC" value="19"/>
							</div>
						</div>
						
						<div class="form-group row m-b-15">
							<label class="col-form-label col-md-3">Minimum X</label>
							<div class="col-md-9">
							<input class="form-control" type="number" placeholder="Minimum Value X"  id="minX" value="0"/>
							</div>
						</div>
							
						<div class="form-group row m-b-15">
							<label class="col-form-label col-md-3">Maximum X</label>
							<div class="col-md-9">
							<input class="form-control" type="number" placeholder="Maximum Value X"  id="maxX" value="70"/>
							</div>
						</div>
						
					<button type="button"   v-on:click="funkcia()" class="btn btn-info m-r-5 m-b-5">Prekresli</button>
						
					</div>
				</panel>
				<!-- end panel -->
			</div>
			<!-- end col-6 -->		
		</div>
		<!-- end row -->
	</div>

</template>

<script>
export default {
  data() {
    var trojholnikovaMF = [];
    var a = 40;
    var b = 55;
    var c = 65;
    var mu = 0;
    for (var i = 0; i < 70; i++) { 
      if (a <= i && i <= b) {
        mu = (i - a) / (b - a);
      }
      if (i == b) {
        mu = 1;
      }
      if (b <= i || i >= c) {
        mu = (c - i) / (c - b);
      }
      if (i <= a || c <= i) {
        mu = 0;
      }
      trojholnikovaMF.push({ x: i, y: mu });
    }

    var trojholnikovaMF2 = [];
    a = 18;
    b = 25;
    c = 30;
    for (i = 0; i < 70; i++) {
      mu = 0;
      if (a <= i && i <= b) {
        mu = (i - a) / (b - a);
      }
      if (i == b) {
        mu = 1;
      }
      if (b <= i || i >= c) {
        mu = (c - i) / (c - b);
      }
      if (i <= a || c <= i) {
        mu = 0;
      }
      trojholnikovaMF2.push({ x: i, y: mu });
    }

    var trojholnikovaMF3 = [];
    a = 25;
    b = 35;
    c = 45;
    for (i = 0; i < 70; i++) {
      mu = 0;
      if (a <= i && i <= b) {
        mu = (i - a) / (b - a);
      }
      if (i == b) {
        mu = 1;
      }
      if (b <= i || i >= c) {
        mu = (c - i) / (c - b);
      }
      if (i <= a || c <= i) {
        mu = 0;
      }
      trojholnikovaMF3.push({ x: i, y: mu });
    }

    var trojholnikovaMF4 = [];
  /*  a = typeof coefA === "undefined" ? 0 : coefA.value;
    b = typeof coefB === "undefined" ? 10 : coefB.value;
    c = typeof coefC === "undefined" ? 19 : coefC.value;
  */
    a = 0; 
    b = 10; 
    c = 19; 
    
    for (i = 0; i < 70; i++) {
      mu = 0;
      if (a <= i && i <= b) {
        mu = (i - a) / (b - a);
      }
      if (i == b) {
        mu = 1;
      }
      if (b <= i || i >= c) {
        mu = (c - i) / (c - b);
      }
      if (i <= a || c <= i) {
        mu = 0;
      }
      trojholnikovaMF4.push({ x: i, y: mu });
    }
    var lineChartData = [
      { values: trojholnikovaMF, key: "mlady", color: "#00ACAC" },
      { values: trojholnikovaMF2, key: "dospely", color: "#eeACAC" },
      { values: trojholnikovaMF3, key: "stary", color: "#ffACAC" },
      { values: trojholnikovaMF4, key: "dieta", color: "#ff00AC" }
    ];
    return {
      lineChart: {
        data: lineChartData
      }
    };
  },
  update() {
    alert("hhhhhahah");
  },
  methods: {
    funkcia() {
      alert("Hodnota: ");
    }
  }
};
</script>